export const PRODUCT_LINES = [
  "Auto",
  "Home",
  "Commercial",
  "Commercial Auto",
  "General Liability",
  "Workers Comp",
  "Commercial Property",
  "Umbrella",
  "RV",
  "Boat",
];

export const CUSTOMER_STATUSES = ["prospect", "active", "inactive", "churned"];

export const POLICY_STATUSES = ["active", "pending", "lapsed", "cancelled"];

export const US_STATES = [
  "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA",
  "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD",
  "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ",
  "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC",
  "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY",
];

export const MAX_DOCUMENT_SIZE_MB = 25;

export const CUSTOMER_DOCUMENT_TYPES = [
  { value: "application", label: "Application" },
  { value: "id_verification", label: "ID verification" },
  { value: "policy_packet", label: "Policy packet" },
  { value: "correspondence", label: "Correspondence" },
  { value: "other", label: "Other" },
];

export const LEAD_STAGES = [
  { value: "new", label: "New lead" },
  { value: "contacted", label: "Contacted" },
  { value: "discovery_call", label: "Discovery" },
  { value: "needs_info", label: "Needs analysis" },
  { value: "quoted", label: "Quoting" },
  { value: "proposal_sent", label: "Proposal sent" },
  { value: "negotiation", label: "Follow up" },
];

export const POLICY_ENDORSEMENT_TYPES = [
  { value: "new_business", label: "New business" },
  { value: "renewal", label: "Renewal" },
  { value: "change", label: "Coverage change" },
  { value: "cancellation", label: "Cancellation" },
];
